import { createVoltraComponent } from './createVoltraComponent.js'
import type { MaskProps } from './props/Mask.js'

export type { MaskProps }
export const Mask = createVoltraComponent<MaskProps>('Mask')
